/* Danielle Alonzo — theme interactions. No framework, no dependencies.

   Every block below is wrapped in step() so that one failure (a missing element,
   a script conflict from a Shopify app) cannot stop the rest from binding. */
(function () {
  "use strict";
  document.documentElement.classList.add("js");

  var onReady = function (fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  };

  function step(label, fn) {
    try { fn(); } catch (err) {
      if (window.console && console.warn) console.warn("[danielle-alonzo] " + label + " failed:", err);
    }
  }

  /* init() re-runs on shopify:section:load, so every listener is registered
     once per element. Without this, a re-render would double-bind the press
     toggles and each click would open then immediately close them. */
  function bindOnce(el, type, fn) {
    var key = "daBound" + type;
    if (el.dataset[key]) return;
    el.dataset[key] = "1";
    el.addEventListener(type, fn);
  }

  function revealAll() {
    var h = document.documentElement;
    h.className = h.className.replace(/\bjs-reveal\b/, "");
  }

  function init() {
     /* Shopify marks EVERY contact form on the page as posted after any one of
       them submits, so both confirmations render. Keep only the right one. */
    step("form-routing", function () {
      var orderPosted = document.querySelector("[data-order-posted]");
      var contactBanner = document.querySelector('#contact-form [role="status"]');
      if (!orderPosted && !contactBanner) return;
      var wasOrder = false;
      try {
        wasOrder = window.sessionStorage.getItem("daOrderSubmitted") === "1";
        window.sessionStorage.removeItem("daOrderSubmitted");
      } catch (e) {}
      if (wasOrder) {
        if (contactBanner) contactBanner.parentNode.removeChild(contactBanner);
      } else if (orderPosted) {
        orderPosted.parentNode.removeChild(orderPosted);
      }
    });
    /* ---- mobile menu ---- */
    step("nav", function () {
      var toggle = document.querySelector("[data-nav-toggle]");
      var panel = document.querySelector("[data-nav-panel]");
      if (!toggle || !panel) return;
      var label = toggle.querySelector("[data-nav-toggle-label]");

      function setNav(open) {
        panel.setAttribute("data-open", open ? "true" : "false");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        if (label) label.textContent = open ? "Close" : "Menu";
      }

      bindOnce(toggle, "click", function () {
        setNav(panel.getAttribute("data-open") !== "true");
      });

      /* jumping to a section should close the menu behind you */
      [].slice.call(panel.querySelectorAll("a")).forEach(function (link) {
        bindOnce(link, "click", function () { setNav(false); });
      });

      /* returning to desktop width must never leave it stuck open */
      if (!window.__daNavResize) {
        window.__daNavResize = true;
        window.addEventListener("resize", function () {
          if (window.innerWidth > 900) setNav(false);
        });
      }
    });

    /* ---- reveal on scroll ---- */
    step("reveal", function () {
      window.__daRevealReady = true;
      var reveals = [].slice.call(document.querySelectorAll("[data-reveal]:not(.is-in)"));
      if (!("IntersectionObserver" in window)) { revealAll(); return; }
      if (!reveals.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: "0px 0px -40px 0px" });
      reveals.forEach(function (node) { io.observe(node); });
      /* belt and braces: anything still hidden after 4s gets shown */
      window.setTimeout(function () {
        [].slice.call(document.querySelectorAll("[data-reveal]:not(.is-in)")).forEach(function (n) {
          var r = n.getBoundingClientRect();
          if (r.top < window.innerHeight * 1.5) n.classList.add("is-in");
        });
      }, 4000);
    });

    /* ---- selected work: accordion + crossfading preview ---- */
    step("work", function () {
    var workButtons = [].slice.call(document.querySelectorAll("[data-work-toggle]"));
    var previews = [].slice.call(document.querySelectorAll("[data-preview]"));
    var previewLabel = document.querySelector("[data-preview-label]");

    function showWork(index) {
      workButtons.forEach(function (button) {
        var i = Number(button.getAttribute("data-work-toggle"));
        var open = i === index;
        var panel = document.querySelector('[data-panel][data-work-panel="' + i + '"]');
        var mark = button.querySelector("[data-work-mark]");
        button.setAttribute("aria-expanded", open ? "true" : "false");
        if (panel) panel.setAttribute("data-open", open ? "true" : "false");
        if (mark) mark.textContent = open ? "\u2212" : "+";
      });
      previews.forEach(function (img) {
        var active = Number(img.getAttribute("data-preview")) === index;
        img.setAttribute("data-active", active ? "true" : "false");
        if (active && previewLabel) previewLabel.textContent = img.getAttribute("data-label") || "";
      });
    }
    workButtons.forEach(function (button) {
      bindOnce(button, "click", function () {
        showWork(Number(button.getAttribute("data-work-toggle")));
      });
    });
    if (workButtons.length) showWork(0);
    });

    /* ---- press accordion (independent open/close) ---- */
    step("press", function () {
    [].slice.call(document.querySelectorAll("[data-press-toggle]")).forEach(function (button) {
      bindOnce(button, "click", function () {
        var panel = document.querySelector('[data-panel][data-press-panel="' + button.getAttribute("data-press-toggle") + '"]');
        if (!panel) return;
        var open = panel.getAttribute("data-open") !== "true";
        panel.setAttribute("data-open", open ? "true" : "false");
        button.setAttribute("aria-expanded", open ? "true" : "false");
        var action = button.querySelector("[data-press-action]");
        if (action) action.textContent = open ? "Close" : "Open";
      });
    });
    });

    /* ---- dialogs: lightbox, legal drawer, order modal ---- */
    var lastFocus = null;

    function openDialog(name) {
      var dialog = document.querySelector('[data-dialog="' + name + '"]');
      if (!dialog) return;
      lastFocus = document.activeElement;
      dialog.setAttribute("data-open", "true");
      document.body.classList.add("is-locked");
      var focusable = dialog.querySelector("button, [href], input, select, textarea");
      if (focusable) focusable.focus();
    }

    function closeDialogs() {
      [].slice.call(document.querySelectorAll("[data-dialog]")).forEach(function (dialog) {
        dialog.setAttribute("data-open", "false");
      });
      document.body.classList.remove("is-locked");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    /* gallery lightbox */
    [].slice.call(document.querySelectorAll("[data-photo]")).forEach(function (button) {
      bindOnce(button, "click", function () {
        var index = button.getAttribute("data-photo");
        [].slice.call(document.querySelectorAll("[data-shot]")).forEach(function (img) {
          img.setAttribute("data-open", img.getAttribute("data-shot") === index ? "true" : "false");
        });
        openDialog("lightbox");
      });
    });

    /* legal drawer */
    [].slice.call(document.querySelectorAll("[data-legal]")).forEach(function (button) {
      bindOnce(button, "click", function () {
        var key = button.getAttribute("data-legal");
        [].slice.call(document.querySelectorAll("[data-legal-doc]")).forEach(function (doc) {
          doc.setAttribute("data-open", doc.getAttribute("data-legal-doc") === key ? "true" : "false");
        });
        openDialog("legal");
      });
    });

    /* order modal */
    var orderSelect = document.querySelector("[data-order-item]");
    var orderSizeWrap = document.querySelector("[data-order-size-wrap]");
    var orderSize = document.querySelector("[data-order-size]");
    var orderSizeLabel = document.querySelector("[data-order-size-label]");
    var orderCta = document.querySelector("[data-order-cta]");
    var TEE_SIZES = ["S", "M", "L", "XL", "XXL"];
    var PRICES = { tee: "$35", cap: "$27", both: "$62" };

    function syncOrderItem() {
      if (!orderSelect) return;
      var value = orderSelect.value;
      var isCap = value === "cap";
      if (orderSizeLabel) orderSizeLabel.textContent = isCap ? "Size" : "Tee Size";
      if (orderCta) orderCta.textContent = "Place Order \u00b7 " + (PRICES[value] || PRICES.tee);
      if (orderSize) {
        orderSize.innerHTML = "";
        (isCap ? ["One Size"] : TEE_SIZES).forEach(function (size) {
          var option = document.createElement("option");
          option.value = size;
          option.textContent = size;
          orderSize.appendChild(option);
        });
        orderSize.required = true;
      }
      if (orderSizeWrap) orderSizeWrap.style.opacity = isCap ? "0.65" : "1";
    }
    if (orderSelect) {
      bindOnce(orderSelect, "change", syncOrderItem);
      syncOrderItem();
    }

    [].slice.call(document.querySelectorAll("[data-order-open]")).forEach(function (button) {
      bindOnce(button, "click", function () {
        var item = button.getAttribute("data-order-open");
        if (orderSelect && (item === "tee" || item === "cap" || item === "both")) {
          orderSelect.value = item;
          syncOrderItem();
        }
        var form = document.querySelector('[data-order-pane="form"]');
        var sent = document.querySelector('[data-order-pane="sent"]');
        if (form) form.setAttribute("data-open", "true");
        if (sent) sent.setAttribute("data-open", "false");
        openDialog("order");
      });
    });

    /* shared close behaviour */
    [].slice.call(document.querySelectorAll("[data-dialog-close]")).forEach(function (button) {
      bindOnce(button, "click", closeDialogs);
    });
    [].slice.call(document.querySelectorAll("[data-dialog]")).forEach(function (dialog) {
      bindOnce(dialog, "click", function (event) {
        if (event.target === dialog) closeDialogs();
      });
    });
    [].slice.call(document.querySelectorAll("[data-dialog-stop]")).forEach(function (panel) {
      bindOnce(panel, "click", function (event) { event.stopPropagation(); });
    });
    if (!window.__daEscBound) {
      window.__daEscBound = true;
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") closeDialogs();
      });
    }

    /* compose a readable order summary into contact[body] before submit */
    var orderForm = document.getElementById("order-form");
    if (orderForm) {
      bindOnce(orderForm, "submit", function () {
                try { window.sessionStorage.setItem("daOrderSubmitted", "1"); } catch (e) {}

        var body = orderForm.querySelector('[name="contact[body]"]');
        if (!body) return;
        var get = function (name) {
          var field = orderForm.querySelector('[name="contact[' + name + ']"]');
          return field ? field.value : "";
        };
        var itemValue = get("Item");
        var itemLabel = itemValue;
        if (orderSelect && orderSelect.selectedIndex > -1) itemLabel = orderSelect.options[orderSelect.selectedIndex].textContent.trim();
        var notes = get("Notes");
        body.value = [
          "MERCH ORDER",
          "Item: " + itemLabel,
          "Size: " + get("Size"),
          "Quantity: " + get("Quantity"),
          "Name: " + get("name"),
          "Email: " + get("email"),
          "Shipping address: " + get("Shipping address"),
          "Notes: " + (notes || "—")
        ].join("\n");
      });
    }

    /* reopen the order modal on Shopify's post-submit reload */
    var orderPosted = document.querySelector("[data-order-posted]");
    if (orderPosted) {
      var formPane = document.querySelector('[data-order-pane="form"]');
      var sentPane = document.querySelector('[data-order-pane="sent"]');
      if (formPane) formPane.setAttribute("data-open", "false");
      if (sentPane) sentPane.setAttribute("data-open", "true");
      openDialog("order");
    }

    /* TikTok embed */
    step("tiktok", function () {
      if (document.querySelector(".tiktok-embed") && !document.getElementById("tiktok-embed-script")) {
        var tiktok = document.createElement("script");
        tiktok.id = "tiktok-embed-script";
        tiktok.src = "https://www.tiktok.com/embed.js";
        tiktok.async = true;
        document.body.appendChild(tiktok);
      }
    });
  }

  onReady(function () { step("init", init); });

  /* Shopify theme editor re-renders sections in place; rebind when it does. */
  document.addEventListener("shopify:section:load", function () { step("re-init", init); });
  document.addEventListener("shopify:section:unload", function () { document.body.classList.remove("is-locked"); });

  /* Last resort: if anything above threw before the reveal step, still show the page. */
  window.addEventListener("load", function () {
    if (!window.__daRevealReady) revealAll();
  });
})();
